import { ColocaProgress } from "@/shared/components/feedback/ColocaProgress";
import { ColocaSurface } from "@/shared/components/layout/ColocaSurface";
import useTranslations from "@/shared/lang/useTranslations";

export interface BatchValidatingPanelProps {
  rowCount: number;
}

/** While the validation job runs: no percentage to promise, so the bar pulses and the copy says what happens. */
export function BatchValidatingPanel({ rowCount }: BatchValidatingPanelProps) {
  const { t } = useTranslations("payoutBatches");
  return (
    <ColocaSurface padding="lg" className="space-y-4">
      <div className="space-y-1">
        <h2 className="text-lg font-semibold text-foreground">
          {t("validating_title", { count: rowCount })}
        </h2>
        <p className="text-sm text-muted-foreground">{t("validating_description")}</p>
      </div>
      <ColocaProgress value={null} size="lg" aria-label={t("validating_title", { count: rowCount })} />
    </ColocaSurface>
  );
}
